var exports = {
  "qr": "EditingMessageInput.module__footer___Qlc2Nj",
  "s6": "EditingMessageInput.module__footerLink___Qlc2Nj",
  "me": "EditingMessageInput.module__separator___Qlc2Nj",
  "EN": "EditingMessageInput.module__editor___Qlc2Nj",
};

module.exports = exports;
